export enum ProLaborLevelDesignationName {
  DepartmentLaborLevel = 'DepartmentLaborLevel',
  PositionLaborLevel = 'PositionLaborLevel',
  UnitLaborLevel = 'UnitLaborLevel',
}

export enum ProLaborLevelDesignationId {
  DepartmentLaborLevel = 1,
  PositionLaborLevel = 2,
  UnitLaborLevel = 3,
}
export const DEFAULT_LABOR_LEVEL_NAMES: Record<string, string> = {
  [ProLaborLevelDesignationName.DepartmentLaborLevel]: 'Department',
  [ProLaborLevelDesignationName.PositionLaborLevel]: 'Position',
  [ProLaborLevelDesignationName.UnitLaborLevel]: 'Unit',
};
